import { render, staticRenderFns } from "./AngleViz.vue?vue&type=template&id=ec1e4f3e&scoped=true"
import script from "./AngleViz.vue?vue&type=script&lang=js"
export * from "./AngleViz.vue?vue&type=script&lang=js"
import style0 from "./AngleViz.vue?vue&type=style&index=0&id=ec1e4f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1e4f3e",
  null
  
)

export default component.exports